var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 5h8a3 3 0 0 1 3 3v4a3 3 0 0 1-2 2.83v2.07a5 5 0 0 0 4-4.9V8a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v4a5 5 0 0 0 5 5h5.667L12 15H8a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17 14.83a1 1 0 0 1 1 1V20a1 1 0 0 1-1.625.78l-5-4a1 1 0 1 1 1.25-1.56L16 17.92v-2.09a1 1 0 0 1 1-1M10.526 6.25a.75.75 0 0 1 .666.462l1.961 4.706 1.223-1.834A.75.75 0 0 1 15 9.25h2a.75.75 0 0 1 0 1.5h-1.599l-1.777 2.666a.75.75 0 0 1-1.316-.127L10.438 8.8l-.767 1.534A.75.75 0 0 1 9 10.75H7a.75.75 0 0 1 0-1.5h1.536L9.83 6.665a.75.75 0 0 1 .697-.415",
  clipRule: "evenodd"
})));
export default SvgGemChat;